<template>
  <div class="main-content">
    <TableComponent
        section="document.Document"
        sectionRoot="document_list"
        moduleName="Document"
    ></TableComponent>
  </div>
</template>

<script>
import TableComponent from '@/components/common/other/table/TableComponent';

export default {
  name: 'Table',
  components: {
    TableComponent
  }
};
</script>
